import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { getPriceValue, readStyle } from "./indicatorUtils";

export const createCCI = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const applyTo = (values["Apply to"] as string) ?? "Typical Price (HLC/3)";
  const cciS = readStyle(styles, "cci", "#2196F3");

  return {
    name: "cci",
    shortName: `CCI${period}`,
    calcParams: [period, applyTo],
    series: "normal" as const,
    figures: [{ key: "cci", title: `CCI${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(cciS.color, 2, lineStyleToKLine(cciS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "cci", title: `CCI${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p, priceField] = (indicator.calcParams ?? [period, applyTo]) as [
        number,
        string,
      ];
      const n = dataList.length;
      const results: Array<{ cci?: number }> = new Array(n);
      const window: number[] = new Array(p);
      let winIdx = 0;
      let winCount = 0;
      let sum = 0;

      for (let i = 0; i < n; i++) {
        const tp = getPriceValue(dataList[i]!, priceField);
        const evicted = winCount === p ? window[winIdx]! : 0;
        window[winIdx] = tp;
        winIdx = (winIdx + 1) % p;
        if (winCount < p) winCount++;
        sum += tp;
        if (winCount === p) sum -= evicted;

        if (i < p - 1) {
          results[i] = {};
          continue;
        }

        const sma = sum / p;
        let md = 0;
        for (let j = 0; j < p; j++) {
          md += Math.abs(window[j]! - sma);
        }
        md /= p;
        results[i] = {
          cci: md === 0 ? 0 : (tp - sma) / (0.015 * md),
        };
      }

      return results;
    },
  };
};
